export function ModalCloseButton({
  onClick,
  disabled,
  label = "Close modal"
}: {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <button
      type="button"
      className="modal-close-button"
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
    >
      <span aria-hidden="true" />
    </button>
  );
}
